module.exports = __webpack_public_path__ + "static/media/wakanda.aafa88b4.png";